import { Box } from '@zillow/constellation-10';

import { LoadingButton, LoadingText } from '@zg-rentals/loading-components';

const LabelAndInputSkeleton = () => (
  <>
    <LoadingText isLoading={true} loadingWidth="100px" textStyle="heading-xs" css={{ marginBottom: '100' }}>
      &nbsp;
    </LoadingText>
    <LoadingText isLoading={true} loadingWidth="100%" textStyle="heading-md" css={{ marginBottom: '300' }}>
      &nbsp;
    </LoadingText>
  </>
);

export const PaymentMethodIframeSkeleton = () => (
  <Box data-testid="PaymentMethodIframeSkeleton">
    {/* Name */}
    <LabelAndInputSkeleton />
    {/* Card number */}
    <LabelAndInputSkeleton />
    {/* Card type */}
    <LoadingText isLoading={true} loadingWidth="100px" textStyle="heading-xs" css={{ marginBottom: '100' }}>
      &nbsp;
    </LoadingText>
    <br />
    <LoadingText isLoading={true} loadingWidth="240px" textStyle="heading-sm" css={{ marginBottom: '300' }}>
      &nbsp;
    </LoadingText>
    <br />
    {/* Security code / ZIP */}
    <LabelAndInputSkeleton />
    {/* Expiration date */}
    <LabelAndInputSkeleton />
    {/* Submit */}
    <LoadingButton isLoading={true} loadingWidth="100%" css={{ marginBottom: '25' }}>
      &nbsp;
    </LoadingButton>
  </Box>
);
